import Vue from "vue";
import vailcode from "@utils/errcode";
import lang from "@i18n/i18nOption.json";
const { langDefault, langList } = lang;
export default {
  namespaced: true,
  state: {
    chatInfo: {
      chatList: null,
      conversation_id: null,
    }
  },
  mutations: {},
  actions: {
    getChatHistory: (_, params={}) => {
      return new Promise(async (resolve, reject) => {
        const res = await _v.$http.post("/chat/history", params);
        vailcode(
          res,
          () => {
            const data = res.data;
            if (!data) {
              reject(null);
              return;
            }
            resolve(data);
          },
          () => {
            reject(null);
          }
        );
      });
    },
    chatTextFnc: (_, params) => {
      return new Promise(async (resolve, reject) => {
        const res = await _v.$http.post("/chat/chat", params);
        vailcode(
          res,
          () => {
            const data = res.data;
            if (!data) {
              reject(null);
              return;
            }

            resolve(data);
          },
          () => {
            reject(null);
          }
        );
      });
    },
  },
  getters: {},
};
